import util from '@/libs/util'
import deepmerge from '@/libs/deepmerge'
import common from './common'
import {repair, repairUrls} from './gip/repair'
import {certificate, certificateUrls} from './gip/certificate'
import {record, recordUrls} from './gip/record'
import {service, serviceUrls} from './gip/service'
import {account, accountUrls} from './gip/account'
import {home, homeUrls} from './gip/home'
import {device, deviceUrls} from './gip/device'
import {order, orderUrls} from './gip/order'
import {register, registerUrls} from './gip/register'
import {message} from './gip/message'
import {login} from './gip/login'
import {router} from '../router'
// 简化api查询方法URL
const urls = [
  ...repairUrls,
  ...certificateUrls,
  ...recordUrls,
  ...serviceUrls,
  ...accountUrls,
  ...homeUrls,
  ...deviceUrls,
  ...orderUrls,
  ...registerUrls
]

function lowerToHyphenUpper (match) {
  return match.replace('-', '').toUpperCase()
}

let urlApis = {}
urls.forEach(url => {
  let result = url.split('/').reduceRight((accumulator, currentValue) => {
    if (currentValue === '') {
      return accumulator
    }
    let obj = {}
    obj[currentValue.replace(/-\w/g, lowerToHyphenUpper)] = accumulator
    return obj
  }, function (params) {
    if (util.loginTimeOut()) {
      router.push({name: 'login'})
    } else {
      return util.ajax.post(url, params)
    }
  })
  urlApis = deepmerge(urlApis, result)
})

// 自定义查询方法
let apis = {
  ...repair,
  ...certificate,
  ...record,
  ...service,
  ...account,
  ...home,
  ...login,
  ...device,
  ...order,
  ...message,
  ...register,
  common
}

export default deepmerge(apis, urlApis)



// WEBPACK FOOTER //
// ./src/api/index.js